/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Spotlight = [
  ["path", { d: "M15.295 19.562 16 22" }],
  ["path", { d: "m17 16 3.758 2.098" }],
  ["path", { d: "m19 12.5 3.026-.598" }],
  [
    "path",
    {
      d: "M7.61 6.3a3 3 0 0 0-3.92 1.3l-1.38 2.79a3 3 0 0 0 1.3 3.91l6.89 3.597a1 1 0 0 0 1.342-.447l3.106-6.211a1 1 0 0 0-.447-1.341z"
    }
  ],
  ["path", { d: "M8 9V2" }]
];

export { Spotlight as default };
//# sourceMappingURL=spotlight.js.map
